<template>
  <div class="contacto">
    <v-container fluid class="min-height-section py-0">
      <v-row>
        <v-col cols="12" md="4" class="pa-0">
          <div class="pa-6 pa-md-12">
            <div>
              <span class="white--text uppercase titles bold">contacto</span>
            </div>

            <div class="margin-custom-1">
              <span class="white--text subtitles">Dirección</span>
            </div>

            <div class="margin-custom-2">
              <span class="white--text">
                <a
                  target="_blank"
                  href="https://goo.gl/maps/ZKDhZJVxArBwGtMM8"
                  class="white--text"
                >Calle 15 de Mayo No. 1410 Pte.</a>
              </span>
              <br />
              <span>
                <a
                  target="_blank"
                  href="https://goo.gl/maps/ZKDhZJVxArBwGtMM8"
                  class="white--text"
                >Monterrey Nuevo León</a>
              </span>
              <br />
              <span>
                <a
                  target="_blank"
                  href="https://goo.gl/maps/ZKDhZJVxArBwGtMM8"
                  class="white--text"
                >CP. 64000</a>
              </span>
              <br />
              <a href="tel:183432000" target="_blank" class="white--text">Tel. 18.343.2000</a>
              <br />
              <div class="d-flex">
                <div>
                  <a
                    href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                    target="_blank"
                  >
                    <v-img src="@/assets/svg/whatsapp.svg" class="d-inline-block" width="18"></v-img>
                  </a>
                </div>
                <div class="pl-1">
                  <a
                    href="https://api.whatsapp.com/send?phone=8180201878&text=Esto%20es%20una%20prueba."
                    target="_blank"
                    class="white--text"
                  >8180201878</a>
                </div>
              </div>
            </div>

            <div class="margin-custom-2">
              <span class="white--text">Síguenos en:</span>

              <ul class="px-0 contact-social-networks">
                <li>
                  <a
                    href="https://www.facebook.com/Martinez-Lozano-y-Asociados-Contadores-P%C3%BAblicos-SC-108434833831743"
                    target="_blank"
                  >
                    <v-img src="@/assets/png/fb.png" class="facebook-icon contact-icons"></v-img>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/mlcp.mx/" target="_blank">
                    <v-img src="@/assets/png/instagram.png" class="instagram-icon contact-icons"></v-img>
                  </a>
                </li>
                <!-- <li>
                  <v-img src="@/assets/svg/tw.svg" class="twitter-icon contact-icons"></v-img>
                </li>
                <li>
                  <v-img src="@/assets/svg/yt.svg" class="youtube-icon contact-icons"></v-img>
                </li>
                <li>
                  <v-img src="@/assets/svg/blogger.svg" class="blogger-icon contact-icons"></v-img>
                </li>-->
              </ul>
            </div>

            <div class="margin-custom-3">
              <div>
                <router-link to="/cita">
                  <span class="white--text link-with-decoration">Agenda tu cita</span>
                </router-link>
              </div>

              <div class="mt-5">
                <router-link to="/solicitud-de-empleo">
                  <span class="white--text link-with-decoration">Solicitud de empleo</span>
                </router-link>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="8" class="pa-0">
          <v-img src="@/assets/img/Fachadacontacto.jpg" class="img-contacto"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  mounted: function () {
    this.$emit("update", 1);
  },
};
</script>

